<script lang="typescript">
    import type { LensBenefit } from "./types";

    export let benefit: LensBenefit;
    export let mouseOverTarget: string;
    export let showTicks: boolean = false;

    let overlay: HTMLDivElement;

    const handleMouseEnter = () => {
        overlay.classList.remove("opacity-10");
        overlay.classList.add("opacity-0");

        document.querySelectorAll(mouseOverTarget).forEach((element) => {
            element.classList.add("highlighted");
        });
    };
    const handleMouseLeave = () => {
        overlay.classList.add("opacity-10");
        overlay.classList.remove("opacity-0");
        document.querySelectorAll(mouseOverTarget).forEach((element) => {
            element.classList.remove("highlighted");
        });
    };
    let isSVG: boolean = benefit.image.endsWith(".svg");
</script>

<div
    style="width: 275px;"
    class="flex flex-col items-start text-center cursor-default h-14 img-container"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
>
    <div class="relative flex flex-row items-start justify-center h-full px-2 space-x-2">
        <img
            class="w-12 h-12 rounded-full object-cover {isSVG ? 'bg-primary-light' : ''}"
            src={benefit.image}
            alt="lens benefit"
        />
        <div class="hide-on-hover img-overlay opacity-10" bind:this={overlay} />
        <h4 class="flex self-center">{benefit.title}</h4>
    </div>
</div>
